<template>
    <div>
        <van-popup v-model="successModalShow"  round closeable :close-icon="ic_close"  close-icon-position="bottom-right">
            <div class="sucess_modal">
                <div class="success_content">
                    <p>恭喜您<br>3天会员体验卡已生效</p>
                    <div class="btn" @click="goDo">
                        立即体验
                    </div>
                </div>
            </div>
        </van-popup>
        <van-popup v-model="copyModalShow" round closeable>
            <div class="copy_content">
                <span>您的邀请码已复制</span>
                <div class="desc">
                    <p>1、选择微信好友或微信群</p>
                    <p>2、「粘贴」发送给好友</p>
                </div>
                <div class="btn" @click="goWeChat">去微信粘贴</div>
            </div>
        </van-popup>
        <van-popup v-model="inputCodeShow" round closeable>
            <div class="input_content">
                <span>好友邀请码</span>
                <!-- 限制只能输入数字 -->
                <input 
                    type="text" 
                    autofocus="autofocus" 
                    ref="codeInput" 
                    oninput="value=value.replace(/[^\d]/g,'')">
                <div class="btn" @click="submit">提交</div>
            </div>
        </van-popup>
        <invite-code
            :inviteCode = "data.inviteCode"
            :canFillInCode = "data.canFillInCode"
            @handleCopy="handleCopy"
            @handleInputCode="handleInputCode"></invite-code>
        
        <invite-get :inviteData="data"></invite-get>
        <invite-share-bottom
            style="width:100%;position:fixed;bottom:0;left:0"
            @handleBottomShare="handleBottomShare"
            :show.sync="showBottomShare"
        ></invite-share-bottom>
        <div class="share-wrap" v-if="showDoShare" @click="handleShareClose"             
            style="width:100%;position:fixed;bottom:0;left:0">
            <invite-share :shareUrl="data.shareUrl" :shareTitle="data.shareTitle" :shareDesc="data.shareDesc" @closeWrap="shareClose"
                actionCode="hzxx3116"></invite-share>
        </div>
    </div>
</template>
<script>
import ajax from '@/api/ajax';
import utils from "@/assets/js/utils";
import inviteCode from "./common/invite-code";//邀请码
import inviteGet from "./common/invite-get";//兑换学贝
import inviteShareBottom from "./common/invite-share-bottom";//邀请
import Modal from '@/components/dumb/modal/modal-new';
import inviteShare from './common/invite-share';

const token = utils.getQueryString("token");
const version = utils.getQueryString("version");
const source = utils.getQueryString("source");

export default{
    components:{
        inviteGet,
        inviteCode,
        inviteShareBottom,
        Modal,
        inviteShare,
    },
    data(){
        return {
            cardId: "",
            showDoShare: false,
            showBottomShare: false,
            successModalShow: false,
            copyModalShow: false,
            inputCodeShow: false,
            ic_close:require("../../../assets/images/common/ic_close.png"),
            data: {
               inviteCode: "00000",
                canFillInCode: 1,
                inviteNum: "90",
                coinNum: "1300",
                expectCoinNum: "2300",
                inviteList: [
                    {
                        studentId: 3234,
                        userName: "昵称1",
                        coin: 100
                    },
                    {
                        studentId: 3234,
                        userName: "昵称2",
                        coin: 200
                    },
                    {
                        studentId: 3234,
                        userName: "昵称3",
                        coin: 400
                    },
                    {
                        studentId: 3234,
                        userName: "昵称",
                        coin: 600
                    },
                ],
                productList: [
                    {
                        title: "标题111",
                        desc: "描述1111",
                        coverImg: "https://appd.knowbox.cn/ss/app-icon/xhls/216_216.png",
                        jumpUrl: "跳转",
                    },
                    {
                        title: "标题2222",
                        desc: "描述2222",
                        coverImg: "https://appd.knowbox.cn/ss/app-icon/xhls/216_216.png",
                        jumpUrl: "跳转",
                    }
                ],
                moreProductUrl : "更多商品地址",
                shareTitle : "分享标题",// 分享标题,会员活动新增
                shareDesc : "分享描述",// 分享描述,会员活动新增
                shareUrl : "www.baidu.com",// 分享地址,会员活动新增
                experienceUrl: "www.baidu.com",
            }
        }
    },
    mounted() {
        this.initData();
        this.doLog(0)
    },
    methods:{
        async initData() {
            let self = this;
            const [resp] = await ajax.all([
                ajax.get('/pay/member-act/invite-task-info', {
                    params: {
                        token: token,
                        version: version,
                        source: source,
                    }
                }),
            ]);
            if(resp.data.code == 99999){
                self.data = resp.data.data;
            }else {
                return;
            }
        },
        handleBottomShare(){
            this.doLog(1)
            this.showDoShare = true;
        },
        async goDo(){
            const [resp] = await ajax.all([
                ajax.post('/student/mall/use-act-member-card', {
                    token: token,
                    version: version,
                    source: source,
                    id: this.cardId,
                }),
            ]);

            if(resp.data.code == 99999){
                this.successModalShow=false;
                // window.location.href = this.data.experienceUrl;
                window.location.href = "hybird://method/openNewWindow?url=" + encodeURIComponent(this.data.experienceUrl + '&hideTitleBar=true');
            }else {
                return;
            }
        },
        handleInputCode(){
            // this.$refs.codeInput.focus()
            this.doLog(3)
            this.inputCodeShow = true
        },
        handleCopy(){
            this.doLog(2)
            this.copyModalShow = true;
        },
        showShare() {
            this.showBottomShare = true;
        },
        handleShareClose(e){
            if (e.target.classList.contains('share-wrap')) {
                this.showDoShare = false;
            }
        },
        shareClose(){
            this.showDoShare = false;
        },
        successModalClose(){
            this.successModalShow = false
        },
        goWeChat(){
            var url = "hybird://method/openBrowser?url=weixin://";
            window.location = url;

            this.copyModalShow = false;
        },
        async submit(){
            const [resp] = await ajax.all([
                ajax.get('/pay/member-act/fill-in-invite-code',{
                    params:{
                        token : token,
                        source : source,
                        version : version,
                        inviteCode : this.$refs.codeInput.value,
                    }
                }),
            ]);

            if(resp.data.code === 99999){
                console.log("fill in success")
                this.inputCodeShow=false;
                this.successModalShow = true;
                this.cardId = resp.data.data.cardId;

                // this.data.canFillInCode = 0;
            }else{
                this.$toast(resp.data.msg)
            }
        },
        doLog(e){
            utils.sendLog({
                token: token,
                version: version,
                source: source,
                extensionJson: {
                    event: e,
                }
            }, 'hzxx3102')
        }
    }
}
</script>

<style lang="scss" scoped>
  .sucess_modal{
    width: 6.1rem;
    height: 8.8rem;
    .success_content{
        width: 6.1rem;
        height: 7.8rem;
        background: url("../../../assets/images/parent_active/invite/bg_invite_success.png") 0 0 /
          cover no-repeat;
        p{
            position:absolute;
            top: 1.2rem;
            left: 00.6rem;
            font-size: 0.46rem;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #fff;
            line-height: 0.68rem;
        }
        .btn{
            position: absolute;
            bottom: 1.6rem;
            margin: auto 0;
            width: 4.64rem;
            height: 0.88rem;
            background: linear-gradient(90deg, #FFDAB1 0%, #FCB170 100%);
            border-radius: 0.44rem;
            text-align: center;
            font-size: 0.32rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #7A3104;
            line-height: 0.44rem;
            margin-left: 0.68rem;
            padding-top: 0.2rem;
        }

    }
  }

    .copy_content{
        background: #fff;
        width: 5.6rem;
        height: 4rem;
        padding: 0.58rem 0.48rem 0.48rem 0.48rem;
        span{
            position: relative;
            font-size: 0.4rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #1B2A42;
            line-height: 0.56rem;
            margin-left: 0.6rem;
        }
        .desc{
            margin-top: 00.2rem;
            p{
                font-size: 0.3rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #3A4961;
                line-height: 0.44rem;
                margin-left: 0.4rem;
            }
        }
        .btn{
            width: 4.64rem;
            height: 0.88rem;
            background: #43A5F3;
            border-radius: 0.44rem;
            font-size: 0.32rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 0.44rem;
            margin-top: 0.48rem;
            text-align: center;
            padding-top: 0.2rem;
        }
    }
    .input_content{
        background: #fff;
        width: 5.6rem;
        height: 4rem;
        padding: 0.58rem 0.48rem 0.48rem 0.48rem;
        span{
            position: relative;
            font-size: 0.4rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #1B2A42;
            line-height: 0.56rem;
            margin-left: 0.6rem;
            margin-left: 1.2rem;
        }
        input{
            margin-top: 00.2rem;
            width: 4.64rem;
            height: 0.88rem;
            background: #E6EAED;
            border-radius: 0.44rem;
            font-size: 0.36rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #1B2A42;
            line-height: 0.48rem;
            padding-left: 00.32rem;
        }
        .btn{
            width: 4.64rem;
            height: 0.88rem;
            background: #43A5F3;
            border-radius: 0.44rem;
            font-size: 0.32rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 0.44rem;
            margin-top: 0.48rem;
            text-align: center;
            padding-top: 0.2rem;
        }
    }
    .van-popup {
        position: fixed;
        max-height: 100%;
        overflow-y: auto;
        background: none;
        -webkit-transition: -webkit-transform .3s;
        transition: -webkit-transform .3s;
        transition: transform .3s;
        transition: transform .3s, -webkit-transform .3s;
        transition: transform .3s,-webkit-transform .3s;
        -webkit-overflow-scrolling: touch;
}
.share-wrap{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background-color: rgba(0,0,0,0.7);
        z-index: 10;
  }
/deep/.van-popup__close-icon--bottom-right {
    right: 3rem;
    bottom: 0;
}
</style>

